let resolveReady: () => void;
let rejectReady: (error: Error) => void;

const readyPromise = new Promise<void>((resolve, reject) => {
  resolveReady = resolve;
  rejectReady = reject;
});

let isSignaled = false;

export const waitForBlocksPlatformReady = () => readyPromise;

export const signalBlocksPlatformReady = () => {
  if (!isSignaled) {
    isSignaled = true;
    resolveReady();
  }
};

export const signalBlocksPlatformFailed = (error: Error) => {
  if (!isSignaled) {
    isSignaled = true;
    rejectReady(error);
  }
};
